export const pathPrefix = '/portal';
